import { Container, Image } from "../../../../src/components/404";
import * as React from 'react';
export default {
  Container,
  Image,
  React
};